import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { buttonClasses } from './styles.js';
import { useUiV2 } from './v2.js';
/**
 * TracePit 管理系の汎用ボタン。各 app に inline 重複していたアクセント/戻る/破壊系
 * ボタンを 1 つに集約する。type は既定で 'button'（誤 submit 防止）。
 */
export const Button = forwardRef(function Button({ variant, size, fullWidth, v2, className, type = 'button', ...rest }, ref) {
    const isV2 = useUiV2(v2);
    return (_jsx("button", { ref: ref, type: type, className: buttonClasses({ variant, size, fullWidth, v2: isV2, className }), ...rest }));
});
//# sourceMappingURL=Button.js.map